export default __webpack_public_path__ + "static/media/foresight.ad7b3283.svg";